import React from "react";
import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import Problem from "../components/landing/Problem";
import Workspaces from "../components/landing/Workspaces";
import SystemArchitecture from "../components/landing/SystemArchitecture";
import HowItWorks from "../components/landing/HowItWorks";
import Projects from "../components/landing/Projects";
import AudienceWhy from "../components/landing/AudienceWhy";
import Trust from "../components/landing/Trust";
import RequestForm from "../components/landing/RequestForm";
import FAQ from "../components/landing/FAQ";
import Footer from "../components/landing/Footer";
import SEO from "../components/SEO";

export default function Home() {
  return (
    <>
      <SEO
        title="Culmora OS — Professional AI Workspace"
        description="Culmora OS is a professional AI workspace in pre-launch development, designed around governed orchestration, human review and approved execution."
        path="/"
      />
      <Header />
      <main id="main" data-testid="home-main">
        <Hero />
        <Problem />
        <Workspaces />
        <SystemArchitecture />
        <HowItWorks />
        <Projects />
        <AudienceWhy />
        <Trust />
        <RequestForm />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}
